// extracted by mini-css-extract-plugin
module.exports = {"card":"hanoi_card__3sw88","table":"hanoi_table__2DaH0","stackCard":"hanoi_stackCard__3VBET","title":"hanoi_title__2XIFY"};